import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary:    '#7c6ff7',
        secondary:  '#34d4a4',
        accent:     '#f9c846',
        background: '#0e0e10',
        surface:    '#18181c',
        error:      '#e24b4a',
        info:       '#378add',
        success:    '#34d4a4',
        warning:    '#ef9f27',
      },
    },
    options: {
      customProperties: true,
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
